import { IconZoomQuestion } from "@tabler/icons-react";
import "./ClientNextStep.scss";
import { Text } from "@mantine/core";

interface ClientNextStepProps {
  clientStatus: string;
}

const ClientNextStep = ({ clientStatus }: ClientNextStepProps) => {
  const getNextSteps = () => {
    switch (clientStatus) {
      case "Quote Sent":
        return {
          title: "Your tax professional has sent you a quote",
          description:
            "Please review it carefully and let your tax professional know if you’d like to proceed.",
        };
      case "Signatures Needed":
        return {
          title: "Your signature is required",
          description:
            "Your tax return is ready for your review and signature. Please carefully review the document and sign it to proceed.",
        };
      case "Waiting":
        return {
          title: "Your tax professional is waiting for your response",
          description:
            "Your tax professional needs your response in order to complete your tax return.",
        };
      case "Ready To Go":
      case "Ready To E-File":
        return {
          title: "Great news! Your return is ready to be e-filed",
          description:
            "You’ll receive notifications for tax return updates. Message your tax professional for any questions on your return.",
        };
      case "Completed":
        return {
          title: "Great news! Your return has been e-filed",
          description:
            "Message your tax professional for any questions on your return.",
        };
      case "Archived":
      case "New":
      case "In Progress":
      default:
        return {
          title: "Great job! No pending tasks from you",
          description:
            "You’ll receive notifications for tax return updates. Message your tax professional for any questions on your return.",
        };
    }
  };

  const { title, description } = getNextSteps();

  return (
    <div className="panel-container client-next-step">
      <div className="panel-header">
        <IconZoomQuestion size={20} />
        <p>What next?</p>
      </div>

      <div className="panel-body">
        <div className="next-steps-description">
          <h2>{title}</h2>
          <Text c="white">{description}</Text>
        </div>
      </div>
    </div>
  );
};

export default ClientNextStep;
